import React from "react";
import styled from "styled-components";
// Assets
import Screenshot1 from "../../assets/img/projects/barbaros.png";
import Screenshot2 from "../../assets/img/projects/keyanagency.png";
import Screenshot3 from "../../assets/img/projects/consultingllc.png";
import Screenshot4 from "../../assets/img/projects/eramsusproject.png";
import Screenshot5 from "../../assets/img/projects/oascanner.png";
import Screenshot6 from "../../assets/img/projects/portfolio.png";

export default function Projects() {
  const projects = [
    {
      img: Screenshot1,
      title: "Barbaros Barbershop",
      description: "A stylish and professional barbershop offering premium grooming services.",
      link: "https://barbaros-barbershop.com/",
    },
    {
      img: Screenshot2,
      title: "Keyan",
      description: "Keyan is a modern e-commerce platform providing a seamless shopping experience.",
      link: "https://keyan.com.tn/",
    },
    {
      img: Screenshot3,
      title: "Consulting Group LLC",
      description: "A consulting firm specializing in business and strategic advisory services.",
      link: "https://keen-stroopwafel-8facc4.netlify.app/",
    },
    {
      img: Screenshot4,
      title: "WEN4SD",
      description: "A platform promoting sustainable development initiatives and solutions.",
      link: "https://wen4sd.com/",
    },
    {
      img: Screenshot5,
      title: "OA Scanner",
      description: "A cutting-edge application for processing and analyzing satellite images.",
      link: "https://oascanner.tn/",
      loginRequired: true, // Add a flag to indicate login required
    },
    {
      img: Screenshot6,
      title: "Ahmed Bensalem Portfolio",
      description: "A personal portfolio showcasing Ahmed Bensalem's work and projects.",
      link: "https://ahmedbensalem.com/",
    },
  ];

  const handleClick = (url, loginRequired) => {
    if (loginRequired) {
      alert(
        "To access the OA Scanner, please use the following credentials:\n\n" +
        "Username: azert@azert.tn\n" +
        "Password: azert123"
      );
    }
    // Redirect to the URL after clicking OK
    window.open(url, "_blank");
  };

  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Awesome Projects</h1>
            <p className="font13">
              Below are some of the live projects we've worked on. Explore their screenshots and visit the sites to learn more.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            {projects.map((project, index) => (
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" key={index}>
                <ProjectBox>
                  <ScreenshotWrapper>
                    <img src={project.img} alt={project.title} />
                  </ScreenshotWrapper>
                  <h3 className="font20 extraBold">{project.title}</h3>
                  <p className="font13">{project.description}</p>
                  <ProjectLink
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default link behavior
                      handleClick(project.link, project.loginRequired);
                    }}
                  >
                    Visit Project
                  </ProjectLink>
                </ProjectBox>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  text-align: center;
`;

const ProjectBox = styled.div`
  background-color: #f9f9f9;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ScreenshotWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 20px;
  
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const ProjectLink = styled.a`
  display: inline-block;
  text-decoration: none;
  color: #fff;
  background-color: #1f1b59;
  margin-top:10px;
  padding: 10px;
  border-radius: 8px;
  width: 100%;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;

  :hover {
    background-color: #27254BFF;
    color: #fff;
  }
`;
